
export class AclAccess {

    id: string;
    name: string;
    level: number;
    read: boolean;
    update: boolean;
    commit: boolean;
    delete: boolean;
    print: boolean;
    archive: boolean;

    constructor(data?: any) {
        if (!data) {
            data = [];
        }

        this.id         = data['id'] ? data['id'] : null;
        this.name       = data['name'] ? data['name'] : null;
        this.level      = data['level'] ? parseInt(data['level'], 10) : 1;
        this.read       = data['read'] ? data['read'] : false;
        this.commit     = data['commit'] ? data['commit'] : false;
        this.update     = data['update'] ? data['update'] : false;
        this.delete     = data['delete'] ? data['delete'] : false;
        this.print      = data['print'] ? data['print'] : false;
        this.archive    = data['archive'] ? data['archive'] : false;
    }

}
